import React from 'react';
import type { Placement } from 'react-joyride';
import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

const WelcomeMessage = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  return (
    <>
      <>
        <b className='text-[20px]'>Olá {user?.name || ''}!</b> Você está no Órbita, a nova plataforma da Eduzz para
        gerir seu negócio online. Vem com a gente nesse tour para descobrir as principais funcionalidades que preparamos
        para você
      </>
      <div className='relative' style={{ position: 'relative' }}>
        <div
          className='absolute top-0 -right-[130px] z-5 block h-[280px] w-[170px] bg-cover bg-center max-sm:hidden'
          style={{ backgroundImage: "url('/img/mascote_edu_apresentando.png')" }}
        />
      </div>
    </>
  );
};
export const steps = [
  {
    target: 'body',
    content: <WelcomeMessage />,
    placement: 'center' as Placement
  },
  {
    target: '#myNotifications',
    content: 'Notificações de afiliação, mensagens e outros avisos importantes estão aqui'
  },
  {
    target: '#myProfile',
    content:
      'Aqui você encontra seu Perfil, nesse menu é possível alterar seus dados cadastrais, consultar suas compras e alterar suas formas de pagamento'
  }
];
